import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { of, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { FinancialAssuranceService } from "../../common/services/financial-assurance.service";
import { LoaderService } from "../../common/services/loader.service";

@Injectable()
export class FaInstrumentResolver  {
  constructor(public dataService: FinancialAssuranceService,
              public loaderService: LoaderService) {
  }

  resolve(route: ActivatedRouteSnapshot) {

      this.loaderService.toggleLoader(true);

      const id = route.paramMap.get('id');
      let obs$: Observable<any> = of(null);
      if (id) {
          obs$ = this.dataService.getBond(id);
      }
      return obs$.pipe(tap((data) => { this.loaderService.toggleLoader(false); }));
  }
}
